/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { AutoAwesome } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import dayjs from 'dayjs'
import {
  IncompleteRestockMetadataFragment,
  IncompleteTaskMetadataFragment,
} from 'graphql/generated-types'
import Markdown from 'react-markdown'

import useT from '@/i18n/useT'
import { MarkdownHelpers } from '@/utils/markdown.helpers'

type IncompleteTaskInsightProps = {
  metadata: IncompleteTaskMetadataFragment | IncompleteRestockMetadataFragment
}

const IncompleteTaskInsight: React.FC<IncompleteTaskInsightProps> = ({
  metadata,
}) => {
  const { t } = useT()
  return (
    <>
      <Stack direction={'row'} alignItems={'center'} spacing={2}>
        <AutoAwesome />
        <Typography variant="h5">
          {t('aiInsightsTable.incompleteTask.missing', {
            date: dayjs(metadata.dueDate).format('dddd MMMM D'),
          })}
        </Typography>
      </Stack>
      <Markdown>{MarkdownHelpers.format(metadata.message)}</Markdown>
    </>
  )
}

export default IncompleteTaskInsight
